import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { notification } from "antd";
import {
  getSchedulesRequest,
  getScheduleStopsRequest,
} from "../../services/schedulesServices";
import { t } from "i18next";

export function* getSchedulesSaga({ token, companyId, from, to, date }) {
  try {
    const response = yield call(
      getSchedulesRequest,
      token,
      companyId,
      from,
      to,
      date
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_SCHEDULES_SUCCESS,
        schedules: response[1],
      });
      yield put({
        type: actions.SCHEDULES_LOADER,
        noSchedules: false,
      });
    } else {
      yield put({
        type: actions.GET_SCHEDULES_SUCCESS,
        schedules: [],
      });
      yield put({
        type: actions.SCHEDULES_LOADER,
        noSchedules: true,
      });
    }
    if (response[0] === 204) {
      yield put({
        type: actions.GET_SCHEDULES_SUCCESS,
        schedules: [],
      });
      yield put({
        type: actions.SCHEDULES_LOADER,
        noSchedules: true,
      });
    }
    if (response[0] === 500) {
      notification.error({
        message: t("problemOccurred"),
        placement: "top",
      });
    }
  } catch (error) {
    notification.error({
      message: t("sessionExpired"),
      placement: "top",
    });
  }
}

export function* getSchedulesTwoWaySaga({ token, companyId, from, to, date }) {
  try {
    const response = yield call(
      getSchedulesRequest,
      token,
      companyId,
      from,
      to,
      date
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_SCHEDULES_TWO_WAY_SUCCESS,
        schedulesTwoWay: response[1],
      });
    } else {
      yield put({
        type: actions.GET_SCHEDULES_TWO_WAY_SUCCESS,
        schedulesTwoWay: [],
      });
    }
    if (response[0] === 500) {
      notification.error({
        message: t("problemOccurred"),
        placement: "top",
      });
    }
  } catch (error) {
    notification.error({
      message: t("sessionExpired"),
      placement: "top",
    });
  }
}

export function* getScheduleStopsSaga({ token, companyId, kursId }) {
  try {
    yield put({
      type: actions.SCHEDULE_STOPS_LOADING,
      schedulesStopsLoading: true,
    });

    const response = yield call(
      getScheduleStopsRequest,
      token,
      companyId,
      kursId
    );

    if (response[0] === 200) {
      yield put({
        type: actions.GET_SCHEDULE_STOPS_SUCCESS,
        scheduleStops: response[1],
      });
      yield put({
        type: actions.SET_OPEN_SCHEDULE_INFO_MODAL,
        value: true,
      });
      yield put({
        type: actions.SCHEDULE_STOPS_LOADING,
        schedulesStopsLoading: false,
      });
    }

    if (response[0] === 500) {
      notification.error({
        message: t("problemOccurred"),
        placement: "top",
      });

      yield put({
        type: actions.SCHEDULE_STOPS_LOADING,
        schedulesStopsLoading: false,
      });
    }
  } catch (error) {
    notification.error({
      message: t("sessionExpired"),
      placement: "top",
    });
    yield put({
      type: actions.SCHEDULE_STOPS_LOADING,
      schedulesStopsLoading: false,
    });
  }
}

export function* getRefundTicketSchedulesSaga({
  token,
  companyId,
  from,
  to,
  date,
}) {
  try {
    const response = yield call(
      getSchedulesRequest,
      token,
      companyId,
      from,
      to,
      date
    );

    if (response[0] === 200) {
      yield put({
        type: actions.GET_REFUND_TICKET_SCHEDULES_SUCCESS,
        refundTicketSchedules: response[1],
      });
    } else {
      yield put({
        type: actions.GET_REFUND_TICKET_SCHEDULES_SUCCESS,
        refundTicketSchedules: [],
      });
    }
    if (response[0] === 500) {
      notification.error({
        message: t("problemOccurred"),
        placement: "top",
      });
    }
  } catch (error) {
    notification.error({
      message: t("sessionExpired"),
      placement: "top",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_SCHEDULES_REQUEST, getSchedulesSaga),
    yield takeEvery(actions.GET_SCHEDULE_STOPS_REQUEST, getScheduleStopsSaga),
    yield takeEvery(
      actions.GET_SCHEDULES_TWO_WAY_REQUEST,
      getSchedulesTwoWaySaga
    ),
    yield takeEvery(
      actions.GET_REFUND_TICKET_SCHEDULES_REQUEST,
      getRefundTicketSchedulesSaga
    ),
  ]);
}
